<template>
  <Loading
    v-if="composable.loading.setting.isShow"
    :content="composable.loading.setting.content"
  />

  <div
    v-if="page === 'initialization'"
    class="page"
  />

  <div
    v-else-if="page === 'showing'"
    class="page"
  >
    <Header
      :setting="{
        title: '媽媽教室預約',
        hasCancelMethod: false,
      }"
      class="mb4"
    />
    <div
      v-if="motheringClasses.length===0"
      class="mv3"
    >
      目前尚無資訊
    </div>
    <div
      v-for="motheringClass in motheringClasses"
      :key="motheringClass"
      class="bc--secondary border-radius-3 row--emphasized pv3 mb4"
    >
      <div class="column--central mh4">
        <div class="mv1">
          {{ moment(motheringClass.date).format('MM/DD') }}
        </div>
        <div class="mv1">
          ({{ moment(motheringClass.date).locale('zh_cn').format('dd') }})
        </div>
      </div>
      <div class="column--central">
        <div class="align--left  fc--primary mv2">
          {{ motheringClass.title }}
        </div>
        <div class="align--left mv2">
          <span class="ellipsis">
            {{ motheringClass.brief }}
          </span>
        </div>
      </div>
      <div class="column--central mh3">
        <div
          @click="showComfirmModal(motheringClass)"
          class="label label--primary"
        >
          預約
        </div>
      </div>
    </div>
  </div>

  <Death
    v-else
    :message="composable.death.message"
    :page="page"
  />

  <Modal
    v-if="composable.modal.setting.isShow"
    :setting="composable.modal.setting"
    @close="composable.modal.close"
    @confirm="call(phone)"
  />
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import composable from '@/composable/index';
import api from '@/api/index';
import spiderman from '@/spiderman/index';

export default {
  setup() {
    const page = ref('initialization');
    const motheringClasses = ref([]);
    const phone = ref('');
    const router = useRouter();
    const route = useRoute();

    onMounted(async () => {
      try {
        composable.loading.show('資料載入中');

        motheringClasses.value = await api.motheringClasses.get(
          composable.member,
        );

        page.value = 'showing';
      } catch (error) {
        page.value = 'death';
        composable.death.show(error);
      } finally {
        composable.loading.close();
      }
    });

    function showComfirmModal(motheringClass) {
      composable.modal.show({
        header: `${motheringClass.title}`,
        body:
              `${spiderman.moment(motheringClass.date).format('MM/DD')}`
              + ` (${spiderman.moment(motheringClass.date).locale('zh_cn').format('dd')})
            ${motheringClass.brief}`,
        footer: [
          {
            content: '來電預約',
            type: 'primary',
            onClickEmit: 'confirm',
          },
        ],
      });
      phone.value = motheringClass.phone;
    }

    function call(phoneNum) {
      const cmd = spiderman.generate.specialCommand({
        cmd: 'browse',
        url: `tel:${phoneNum}`,
        timestamp: spiderman.generate.timestamp(),
      });
      router.replace(`${route.path}#inncom#${cmd}`);
    }

    return {
      page,
      composable,
      moment: spiderman.moment,
      motheringClasses,
      showComfirmModal,
      call,
      phone,
      window,
    };
  },
};
</script>
